import { InvoiceHistoryDataTable } from './components';

function InvoiceHistoryMobileSkeleton(): JSX.Element {
  return <InvoiceHistoryDataTable.Skeleton />;
}
export default InvoiceHistoryMobileSkeleton;
